// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__kqHQb {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.styles_modalWrapper__Yogcs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_subheading__SY4Lp {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_subheading__SY4Lp {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueGrid__khLS6 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
}
@media (max-width: 768px) {
  .styles_valueGrid__khLS6 {
    grid-template-columns: 1fr;
  }
}

.styles_valueWrapper__tDjH4,
.styles_valueContractWrapper__tiEKn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

@media (max-width: 1200px) {
  .styles_valueContractWrapper__tiEKn {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.styles_valueHeading__62tIT {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_valueHeading__62tIT {
    font-size: 12px;
    line-height: 15px;
  }
}

.styles_value__-1bNL,
.styles_valueContract__E55tE {
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .styles_value__-1bNL,
.styles_valueContract__E55tE {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueContract__E55tE {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 1200px) {
  .styles_valueContract__E55tE {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/baseContent/burningContent/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BCbS;ADWX;AEAE;EFJF;IASI,eAAA;IACA,iBAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AADF;AEAE;EFFF;IAMI,0BAAA;EAAF;AACF;;AAGA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAAF;;AEzBE;EF4BF;IAEI,sBAAA;IACA,uBAAA;IACA,QAAA;EAAF;AACF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BCtDS;ADsDX;AEzCE;EFoCF;IAQI,eAAA;IACA,iBAAA;EACF;AACF;;AAEA;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cC1EM;AD2ER;AExDE;EFiDF;;IASI,eAAA;IACA,iBAAA;EAGF;AACF;;AAAA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;AErEE;EF+DF;IAMI,WAAA;EAIF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n}\n\n.modalWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.subheading {\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-80;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 16px;\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.valueWrapper,\n.valueContractWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.valueContractWrapper {\n  @include xl {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n.valueHeading {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n\n  @include xl {\n    font-size: 12px;\n    line-height: 15px;\n  }\n}\n\n.value,\n.valueContract {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueContract {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  @include xl {\n    width: 100%;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__kqHQb`,
	"modalWrapper": `styles_modalWrapper__Yogcs`,
	"subheading": `styles_subheading__SY4Lp`,
	"valueGrid": `styles_valueGrid__khLS6`,
	"valueWrapper": `styles_valueWrapper__tDjH4`,
	"valueContractWrapper": `styles_valueContractWrapper__tiEKn`,
	"valueHeading": `styles_valueHeading__62tIT`,
	"value": `styles_value__-1bNL`,
	"valueContract": `styles_valueContract__E55tE`
};
export default ___CSS_LOADER_EXPORT___;
